const E401 = () => (
  <div className="error-container error-401">
    <h1>401</h1>
    <p className="title">Unauthorized</p>
    <p>You must log in to access this page.</p>
  </div>
);

export default E401;